module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Klyne R. Snodgrass\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("Klyne R. Snodgrass")]), _vm._v(" served as Paul W. Brandel Professor of New Testament Studies at North Park Theological Seminary, Chicago, until his retirement in 2015. His other books include "), _c('I', [_vm._v("Stories with Intent: A Comprehensive Guide to the Parables of Jesus")]), _vm._v(", which won a "), _c('I', [_vm._v("Christianity Today")]), _vm._v(" Book Award.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/q5cK3k/tc-custom/9781467449649.jpg?1730409134834",
      "alt": "This image is the cover for the book Who God Says You Are"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Who God Says You Are\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("WHO ARE YOU?")])]), _c('p', [_vm._v("For respected New Testament scholar Klyne Snodgrass, this is the most important question a person can ask—the question from which everything else in life flows. Other questions follow: "), _c('i', [_vm._v("What made you who you are? Who gets to say who you are?")]), _vm._v(" And—perhaps most vital—"), _c('i', [_vm._v("Who does "), _c('b', [_vm._v("God")]), _vm._v(" say you are?")])]), _c('p', [_vm._v("In this book Snodgrass offers wise guidance to all who are wrestling with such universal human questions. He examines nine factors—including one’s body, personal history, commitments, and boundaries—that shape human identity, and he expertly draws out what the Bible tells us about who God says we are, how we fit within God’s purposes, and how our God-given identity can and must impact the way we live our lives.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0